import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LensMark } from "@/components/brand/ProximaLogo";

export default function NotFoundPage() {
  return (
    <div className="flex min-h-[55vh] flex-col items-center justify-center text-center" data-testid="not-found-page">
      <LensMark className="h-12 w-12 opacity-80" />
      <div className="mono mt-6 text-xs text-muted-foreground">404</div>
      <h1 className="mt-2 text-[26px] font-semibold tracking-tight">Siden finnes ikke</h1>
      <p className="mt-2 max-w-sm text-sm text-muted-foreground">Lenken kan være utdatert, eller du mangler tilgang til innholdet.</p>
      <Button asChild className="mt-7">
        <Link to="/" data-testid="not-found-home-link">
          Til oversikten
        </Link>
      </Button>
    </div>
  );
}
